<template>
  <div v-if="qr" class="qr" data-testid="payment-qr">
    <img v-if="src" :src="src" alt="QR ชำระเงิน" class="qr-image" />
  </div>
</template>

<script>
import QRCode from 'qrcode';

// Renders the QR only while the publisher supplies one. When `qr` becomes
// null (edit after save) the element disappears in the same tick; no stale
// image is kept around while a new one would be generated.
export default {
  name: 'PaymentQr',
  props: {
    qr: { type: Object, default: null }
  },
  data() {
    // customerDisplayQrToken must be initialized here, not in created():
    // an `immediate: true` watcher fires during Vue 2's initWatch step,
    // which runs BEFORE created() -- initializing it there meant the very
    // first (immediate) call incremented `undefined` to NaN, and by the
    // time that race-guard's async QR generation resolved, created() had
    // already reset the real token to 0, so `NaN === 0` was always false
    // and the generated QR image was silently discarded. Found via a
    // failing test, not by inspection.
    return { src: '', customerDisplayQrToken: 0 };
  },
  watch: {
    qr: {
      immediate: true,
      deep: true,
      handler(qr) {
        const mine = ++this.customerDisplayQrToken;
        if (!qr) {
          this.src = '';
          return;
        }
        if (qr.kind === 'image') {
          this.src = qr.url;
          return;
        }
        this.src = '';
        QRCode.toDataURL(qr.payload, { errorCorrectionLevel: 'M', margin: 1, width: 640 })
          .then((url) => {
            if (mine === this.customerDisplayQrToken) this.src = url;
          })
          .catch(() => {
            if (mine === this.customerDisplayQrToken) this.src = '';
          });
      }
    }
  }
};
</script>

<style scoped>
.qr {
  width: 100%;
  aspect-ratio: 1;
  display: grid;
  place-items: center;
  background: #fff;
  padding: 0.6rem;
}
.qr-image {
  /* 90% of the box: a 10% smaller code with extra white space around it,
     while the box (and so the column layout) stays the same size. */
  width: 90%;
  height: 90%;
  object-fit: contain;
}
</style>
